// Grade match bands, mirrored from backend ai_advisor.RULES (inclusive lower bounds on a −1…+1 score).
// `pill` = ChanceBadge text, `band` = band-button text, `legend` = ChanceLegend / API label.
export const BAND_DEFS = [
  {
    key: "likely", pill: "Well-matched", band: "Likely", legend: "Likely", from: 0.5,
    meaning: "Your profile is clearly above the typical entry requirements on file.",
    caveat: "Not a guarantee of an offer.",
  },
  {
    key: "target", pill: "Realistic", band: "Target", legend: "Target", from: -0.15, to: 0.5,
    meaning: "Your profile is around the typical entry requirements: from slightly below to comfortably above.",
  },
  {
    key: "ambitious", pill: "Aspirational", band: "Ambitious", legend: "Ambitious", from: -0.6, to: -0.15,
    meaning: "Your profile is below the typical entry requirements, but not far below.",
  },
  {
    key: "highly_ambitious", pill: "Long shot", band: "Long-shot", legend: "Highly Ambitious", to: -0.6,
    meaning: "Your profile is well below the typical entry requirements, or misses a requirement.",
  },
];

export const bandDef = (bucket) => BAND_DEFS.find((b) => b.key === (bucket === "long_shot" ? "highly_ambitious" : bucket));

export const BAND_FACTORS = "grades (30%), required subjects (30%), test scores (15%), English (10%), your activities rating (10%) and portfolio or interview where required (5%)";

export const BAND_LIMITS = [
  "If this course has no entry requirements on file, the university's general requirements are used.",
  "A big shortfall in a required subject caps the band at Aspirational (or Realistic for a smaller one).",
  "If your grades can't be compared with the requirements listed, the match is pushed down.",
  "Audition and portfolio courses use your own portfolio and activities ratings instead of grades.",
];

export const NOT_A_CHANCE = "This is an academic match category, not a percentage chance of an offer.";
